import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { HardHat, Plus, Trash2, Loader2 } from "lucide-react";

export default function CatalogEditor({ isAdmin }) {
  const [items, setItems] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/catalog").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return null;

  const upd = (i, k, v) => setItems((s) => s.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const add = (kind) => setItems((s) => [...s, { id: `new-${Date.now()}`, name: "", brand: "", kind }]);
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/catalog", items); setItems(r.data); toast.success("Catálogo guardado"); }
    catch { toast.error("No se pudo guardar el catálogo"); }
    finally { setSaving(false); }
  };

  return (
    <Card className="p-6" data-testid="catalog-card">
      <div className="flex items-center gap-2 mb-1">
        <HardHat className="h-5 w-5 text-accent" />
        <h2 className="font-display text-lg font-bold">Catálogo de EPIs y ropa</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-4">Lista predefinida para añadir a las fichas con un clic y para las entregas masivas.</p>
      <div className="grid md:grid-cols-2 gap-4">
        {["epi", "ropa"].map((kind) => (
          <div key={kind} className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{kind === "epi" ? "EPIs" : "Ropa y calzado"}</p>
            {items.map((it, i) => it.kind === kind && (
              <div key={it.id} className="flex gap-2">
                <Input className="h-9 flex-1" placeholder="Denominación" value={it.name} disabled={!isAdmin} onChange={(e) => upd(i, "name", e.target.value)} data-testid={`catalog-name-${it.id}`} />
                <Input className="h-9 w-32" placeholder="Marca" value={it.brand} disabled={!isAdmin} onChange={(e) => upd(i, "brand", e.target.value)} />
                {isAdmin && <Button type="button" size="icon" variant="ghost" className="h-9 w-9 text-red-500" onClick={() => setItems((s) => s.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4" /></Button>}
              </div>
            ))}
            {isAdmin && <Button type="button" size="sm" variant="outline" onClick={() => add(kind)} data-testid={`catalog-add-${kind}`}><Plus className="h-4 w-4 mr-1.5" /> Añadir</Button>}
          </div>
        ))}
      </div>
      {isAdmin && (
        <div className="flex justify-end mt-4">
          <Button onClick={save} disabled={saving} data-testid="catalog-save-button">{saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Guardar catálogo</Button>
        </div>
      )}
    </Card>
  );
}
